package com.anjuros.website.templates.template8.modules

import com.anjuros.website.templates.template8.styles.Template8Theme
import com.anjuros.website.templates.template8.styles.getColor
import com.anjuros.website.templates.template8.util.ResKey
import org.jetbrains.compose.web.css.CSSColorValue

enum class Template8Section(
    val id: String,
    val title: ResKey,
    val path: String,
    val subPath: String = ""
) {


    Home(
        id = "home",
        title = ResKey.TEMPLATE8_HOME,
        path = "/pub-website-design-uk",
        subPath = "#home"
    ),
    Menu(
        id = "menu",

        title = ResKey.TEMPLATE8_INFO_BUTTON_TEXT1,
        path = "/pub-menu-website-design-uk"
    ),
    LearnMore(
        id = "learmore",
        title = ResKey.TEMPLATE8_INFO_BUTTON_TEXT2,
        path = "/pub-learn-more-website-design-uk"
    ),


    WhatsOn(
        id = "whatson",
        title = ResKey.TEMPLATE8_INFO_BUTTON_TEXT3,
        path = "/pub-whats-on-website-design-uk"
    ),
}